import Link from 'next/link';
import React from 'react';

import {
    BrowseAggregatorContent,
    BrowsePageContent,
    PaginatedContent,
    RelatedCertificationAggregatorCarousel,
} from '@udemy/browse-aggregator';
import {CertificationAggregatorApi} from '@udemy/browse-aggregator';
import {ClickEvent, Tracker} from '@udemy/event-tracking';
import {LocalizedHtml, useI18n} from '@udemy/i18n';

import {udemyApi} from 'src/lib/ud-global-fetch';

import {useCertificationBrowseAggregatorContext} from '../../contexts/certification-browse-page-content-context';
import {CARD_CAROUSEL_PAGE_SIZE} from '../../utils/constants';
import styles from './certification-preparation.module.less';

export const RelatedCertificationAggregator = ({
    initialData,
}: {
    initialData: PaginatedContent<BrowsePageContent> | null;
}) => {
    const {gettext, interpolate} = useI18n();
    const certificationAggregatorContext = useCertificationBrowseAggregatorContext();

    if (!initialData) {
        return null;
    }
    const certificationAggregatorApi = new CertificationAggregatorApi(udemyApi);

    const trackAllCertificationsClick = () => {
        Tracker.publishEvent(
            new ClickEvent({
                componentName: 'seeAllCertificationPreparationTitle',
            }),
        );
    };
    function renderRelatedCertificationAggregatorTitle() {
        const template = gettext('Top <a class="certPrepLink">Certification</a> Issuers');
        const htmlWithInterpolatedText = interpolate(template, true);
        return (
            <h2 className={styles['related-certification-aggregator-title']}>
                <LocalizedHtml
                    html={htmlWithInterpolatedText}
                    interpolate={{
                        certPrepLink: (
                            // eslint-disable-next-line jsx-a11y/anchor-has-content
                            <a
                                href="/browse/certification"
                                className="ud-link-underline"
                                aria-label="Certification Preparation"
                                onClick={trackAllCertificationsClick}
                            />
                        ),
                    }}
                />
            </h2>
        );
    }

    return (
        <div className={styles['related-certification-aggregator-wrapper']}>
            {renderRelatedCertificationAggregatorTitle()}
            <RelatedCertificationAggregatorCarousel
                key={`black-friday-cyber-monday-sales-related-content-carousel`}
                title={''}
                browseAggregatorContent={
                    certificationAggregatorContext?.aggregatorContent as BrowseAggregatorContent
                }
                certificationAggregatorApi={certificationAggregatorApi}
                useStackedCards={false}
                initialData={initialData}
                pageSize={CARD_CAROUSEL_PAGE_SIZE}
                aggregatorCardProps={{
                    linkComponent: (props: {href: string; children?: React.ReactNode}) => (
                        <Link {...props} legacyBehavior={false}>
                            {props.children}
                        </Link>
                    ),
                }}
            />
        </div>
    );
};
